module.exports = __webpack_public_path__ + "img/p8-p1-molihua.335d8004.png";